var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createOrder_box" },
    [
      _c(
        "div",
        { staticClass: "page_title" },
        [
          _c("custom-breadcrumb", {
            attrs: { suffix: "Order NO. " + _vm.orderId + "}" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "con_title" }, [_vm._v("Customer")]),
      _vm._v(" "),
      _c("div", { staticClass: "order_search" }, [
        _c("div", [
          _c("div", { staticClass: "search_content flex" }, [
            _c("div", { staticClass: "con_left" }, [
              _c("p", { staticClass: "con_title" }, [_vm._v("Customer")]),
              _vm._v(" "),
              _c("p", { staticClass: "user_info" }, [
                _vm._v("\n            Username: "),
                _c("span", { staticClass: "info_text" }, [
                  _vm._v(_vm._s(_vm.userInfo.userName))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user_info" }, [
                _vm._v("\n            Email: "),
                _c("span", { staticClass: "info_text" }, [
                  _vm._v(_vm._s(_vm.userInfo.email))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user_info" }, [
                _vm._v("\n            Phone: "),
                _c("span", { staticClass: "info_text" }, [
                  _vm._v(_vm._s(_vm.userInfo.phone))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "user_info" }, [
                _vm._v("\n            Store name: "),
                _c("span", { staticClass: "info_text" }, [
                  _vm._v(_vm._s(_vm.userInfo.storeName))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "con_right" }, [
              _c("p", { staticClass: "con_title" }, [
                _vm._v("\n            Ship Total\n            "),
                _c("span", { on: { click: _vm.openAddress } }, [
                  _c("img", {
                    attrs: { src: require("@/assets/img/memo.png"), alt: "" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _vm.tsStoreOrderAddress.addressFirstName &&
                _vm.tsStoreOrderAddress.addressLastName
                  ? _c("p", { staticClass: "user_info" }, [
                      _vm._v(
                        _vm._s(_vm.tsStoreOrderAddress.addressFirstName) +
                          "  " +
                          _vm._s(_vm.tsStoreOrderAddress.addressLastName)
                      ),
                      _c("br")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderAddress.address
                  ? _c("p", { staticClass: "user_info" }, [
                      _vm._v(_vm._s(_vm.tsStoreOrderAddress.address)),
                      _c("br")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderAddress.address &&
                _vm.tsStoreOrderAddress.city &&
                _vm.tsStoreOrderAddress.province &&
                _vm.tsStoreOrderAddress.postCode &&
                _vm.tsStoreOrderAddress.countryName
                  ? _c("p", { staticClass: "user_info" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.tsStoreOrderAddress.city) +
                          ", " +
                          _vm._s(_vm.tsStoreOrderAddress.province) +
                          ", " +
                          _vm._s(_vm.tsStoreOrderAddress.countryName) +
                          ", " +
                          _vm._s(_vm.tsStoreOrderAddress.postCode) +
                          "\n              "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderAddress.phone
                  ? _c("p", { staticClass: "user_info" }, [
                      _vm._v(
                        _vm._s(_vm.tsStoreOrderAddress.areaCode) +
                          "-" +
                          _vm._s(_vm.tsStoreOrderAddress.phone)
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "con_title" }, [_vm._v("Order details")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "creat_order" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tsStoreOrderDetailList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Item", width: "640" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "prduct_box" }, [
                          _c("img", {
                            staticClass: "product_img",
                            attrs: { src: scope.row.skuImg, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "product_info" }, [
                            _c("p", { staticClass: "product_name" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.skuName) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "product_size" }, [
                              _vm._v(_vm._s(scope.row.skuParam1))
                            ])
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "Wholesale Price", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "prduct_box flex_all" },
                          [
                            _c("el-input", {
                              staticClass: "price_input",
                              attrs: { placeholder: "wholesalePrice" },
                              on: {
                                change: function($event) {
                                  return _vm.countAllTotalPrice(
                                    scope.$index,
                                    scope.row.unitPrice,
                                    scope.row.unitPriceBeforeDiscount
                                  )
                                }
                              },
                              model: {
                                value: scope.row.unitPrice,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "unitPrice", $$v)
                                },
                                expression: "scope.row.unitPrice"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  scope.row.deleteLine ||
                                  scope.row.unitPrice !=
                                    scope.row.unitPriceBeforeDiscount
                                    ? "dis_price dis_line"
                                    : "dis_price"
                              },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(scope.row.unitPriceBeforeDiscount)
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "Qty" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "prduct_box flex_all qty-left" },
                          [
                            _c("el-input", {
                              staticClass: "price_input",
                              attrs: { placeholder: "Qty" },
                              on: {
                                change: function($event) {
                                  return _vm.countAllTotalChange(
                                    scope.$index,
                                    scope.row.num
                                  )
                                }
                              },
                              model: {
                                value: scope.row.num,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "Total" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "flex total_amount" }, [
                          _c("span", [
                            _vm._v("$" + _vm._s(scope.row.commodityAmount))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "order-delete",
                              on: {
                                click: function($event) {
                                  return _vm.deleteOrder(scope.row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-bottom" }, [
        _c("div", { staticClass: "product-bottom-memo" }, [
          _c("div", [
            _c("div", { staticClass: "memo-text" }, [_vm._v("Memo")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: "8",
                    placeholder: "Fill out Memo",
                    maxlength: "500",
                    "show-word-limit": ""
                  },
                  nativeOn: {
                    keydown: function($event) {
                      return _vm.memoChange($event)
                    }
                  },
                  model: {
                    value: _vm.tsStoreOrderInfo.memo,
                    callback: function($$v) {
                      _vm.$set(_vm.tsStoreOrderInfo, "memo", $$v)
                    },
                    expression: "tsStoreOrderInfo.memo"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "product-bottom-price" }, [
          _vm.orderDetails
            ? _c(
                "div",
                { staticClass: "end_box flex" },
                [
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", [_vm._v("Total quantity")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.tsStoreOrderInfo.goodsNum))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", [_vm._v("Total price of goods")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "$" + _vm._s(_vm.tsStoreOrderInfo.totalPriceBefore)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Product discount")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "brown_text" }, [
                      _c("span", { staticClass: "black_text" }, [_vm._v("-")]),
                      _vm._v(
                        "$" +
                          _vm._s(_vm.tsStoreOrderInfo.productDiscounted) +
                          "\n      "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", { staticClass: "brown_text" }, [
                      _vm._v("Supplier order discount")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm._v("\n        - "),
                        _c("span", { staticClass: "brown_text" }, [
                          _vm._v("$")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "price_input brown_text",
                          attrs: { placeholder: "", clearable: "" },
                          on: { change: _vm.changePrice },
                          model: {
                            value: _vm.tsStoreOrderInfo.orderDiscounted,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tsStoreOrderInfo,
                                "orderDiscounted",
                                $$v
                              )
                            },
                            expression: "tsStoreOrderInfo.orderDiscounted"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text flex" }, [
                    _c("p", {}, [_vm._v("Shipping fee")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c("span", {}, [_vm._v("$")]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "price_input",
                          attrs: {
                            disabled: _vm.disabled,
                            placeholder: "",
                            clearable: ""
                          },
                          on: { change: _vm.changeShipping },
                          model: {
                            value: _vm.tsStoreOrderInfo.totalFreight,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tsStoreOrderInfo,
                                "totalFreight",
                                $$v
                              )
                            },
                            expression: "tsStoreOrderInfo.totalFreight"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "creat_text blod_text flex" }, [
                    _c("p", [_vm._v("Total Amount")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.tsStoreOrderInfo.payAmount))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.editOrder()
                        }
                      }
                    },
                    [_vm._v("Submit")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.successVisible,
            "close-on-click-modal": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.successVisible = $event
            },
            close: function($event) {
              return _vm.backOrderList()
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "back_icon",
              on: {
                click: function($event) {
                  return _vm.backOrderList()
                }
              }
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "success_text" }, [
            _vm._v("Order modified successfully")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.backOrderList()
                    }
                  }
                },
                [_vm._v("Back Order List (" + _vm._s(_vm.seconds) + ")")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("Address", {
            ref: "address",
            attrs: { addressMessage: _vm.addressMessage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fea7d0e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fea7d0e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/editOrder.vue
// module id = 7NP0
// module chunks = 2